import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0f172a] py-20 md:py-28" data-id="element-28">
      <div className="max-w-3xl mx-auto px-6" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-8" data-id="element-30">
          <MoonIcon className="w-12 h-12 text-[#d4a853] mx-auto" data-id="element-31" />

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-white leading-tight" data-id="element-32">
            Esta noche puede ser diferente.
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-33">
            Cada noche que pasa sin descanso profundo, tu cuerpo acumula más
            fatiga, más estrés y más desgaste. No tienes que seguir así.{' '}
            <span className="text-[#d4a853] font-semibold" data-id="element-34">
              El cambio empieza con una decisión.
            </span>
          </p>

          <p className="text-lg text-gray-400" data-id="element-35">
            En 15 minutos tendrás la guía en tus manos. En 5 minutos aplicarás
            el primer protocolo. Y esta misma noche, sentirás la diferencia.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="space-y-4 pt-4" data-id="element-36">
            <motion.a href="#precio" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#d4a853] text-[#0f172a] px-12 py-6 rounded-lg text-xl font-bold shadow-lg hover:shadow-xl transition-shadow cursor-pointer" data-id="element-37">
              QUIERO RECUPERAR MI DESCANSO HOY
            </motion.a>
            <p className="text-sm text-gray-500" data-id="element-38">
              Solo $6.39 USD · Acceso inmediato · Sin riesgo
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}